import styled from "styled-components";
import { device } from "../../constants";
import { TopbarBlog } from "./topbar";
import { useTranslation } from 'next-i18next';

const Container = styled.div`
  padding: 56px 24px;
  width: 100%;
  height: 100%;

  @media ${device.laptop} {
    padding: 80px;
  }
`;

const HeaderContainer = styled.div`
  margin-top: 80px;

  @media ${device.laptop} {
    margin-top: 80px;
  }
`;
const HeroContainer = styled.div`
  height: 600px;
  position: relative;
  
  background-size: cover;
  background-position: 76% center;
  background-repeat: no-repeat;
  background-image: url('/blog/assets/png/banner-blog.png');

  &:after {
    content: '';
    background: linear-gradient(178.83deg, #15191E 1%, rgba(21, 25, 30, 0.738308) 24.36%, rgba(21, 25, 30, 0) 43.63%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media ${device.laptop} {
    height: 430px; 
    background-position: center;
  }
`;

const HeroTitle = styled.h1`
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-01']};
  margin: 0;
  font-size: 22px;
  line-height: 30px;
  position: absolute;
  z-index: 2;
  margin-top: 16px;
  
  @media ${device.laptop} {
    margin-top: 24px;
    font-size: 48px;
    line-height: 64px;
  }

  &:before {
    content: '';
    border-radius: 4px;
    height: 4px;
    position: absolute;
    top: -16px;
      
    width: 32px;
    background-color: ${({ theme }) => theme.colors['vivid-03']};
    
    @media ${device.laptop} {
      width: 48px;
      top: -24px;
    }
  }

  span {
    font-weight: 700;
    color: ${({ theme }) => theme.colors['vivid-03']};
  }
`;

export function Header({ showHero = true }) {
  const { t } = useTranslation();
  return (
    <HeaderContainer>
      <TopbarBlog />
     
      {showHero && <HeroContainer>
        <Container className='container-blog'>
          <HeroTitle>
            {t("banner.blog.title")} <br/>
            <span>{t("banner.blog.subtitle")}</span>
          </HeroTitle>
        </Container>
      </HeroContainer>}
    </HeaderContainer >
  )
}
